import { takeLatest, put, all, call } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_AAC_API } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// ACTIONS
import {
	consultaSituacaoAtualSuccess,
	consultaSituacaoAtualFailure,
} from './actions';

// TYPES
import { Types, RequestConsultaSituacaoAtual } from './types';

function* consultaSituacaoAtualRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: RequestConsultaSituacaoAtual } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_AAC_API,
		`central-liberacao/atendimentos/situacoes`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaSituacaoAtualSuccess(response.data));
	} else if (response.error) {
		yield put(consultaSituacaoAtualFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_SITUACAO_ATUAL_REQUEST,
		consultaSituacaoAtualRequest,
	),
]);
